import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';
import { PartnerParametersService } from '@core/partner-parameters/partner-parameters.service';

import { SettingsSaveTonerService } from './settings-save-toner.service';

@Injectable({
    providedIn: 'root',
})
export class SettingsSaveTonerGuardService implements CanLoad {

    constructor(
        private settingsSaveTonerService: SettingsSaveTonerService,
        private partnerParameterService: PartnerParametersService,
        private authTokenService: AuthTokenService,
        private router: Router,
    ) { }

    public canLoad(): Observable<boolean> {
        // tslint:disable-next-line:no-bitwise
        if (!(this.authTokenService.role & RoleTypes.PartnerMaster)) {
            this.router.navigate(['page-forbidden']);

            return of(false);
        }

        const getLicensing: any = this.settingsSaveTonerService.getLicensing.bind(this.settingsSaveTonerService);
        const saveTonerPermission: any =
            this.partnerParameterService.checkUserPermissionToSaveTonerLicensingManagement.bind(this.partnerParameterService);

        return forkJoin([getLicensing(), saveTonerPermission()])
            .pipe(
                take(1),
                map((results: any[]) => {

                    if (results[0].enabled || results[1]) {
                        return true;
                    }

                    this.router.navigate(['page-forbidden']);

                    return false;
                }));
    }
}
